<!--资源中心菜单-->
<template>
    <div class="menu-container">
        <div @click="changeItem('1','0')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">
            课题引领
        </div>
        <div v-if="activeItem==='1'" class="child-menu-container">
            <div @click="changeItem('1','1')" class="chile-item-container">
                <div :class="activeChildItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">
                    进行中
                </div>
            </div>
            <div @click="changeItem('1','2')" class="chile-item-container">
                <div :class="activeChildItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">
                    已结束
                </div>
            </div>
            <div @click="changeItem('1','3')" class="chile-item-container">
                <div :class="activeChildItem==='3'?'child-menu-item child-menu-active':'child-menu-item'">
                    已发布
                </div>
            </div>
        </div>
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">
            教研赛事
        </div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">
            专题活动
        </div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">
            成果展示
        </div>
    </div>
</template>

<script>

export default {
    name:'eduResearchMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"1",
            activeChildItem:"0",
        }
    },
    methods: {
        changeItem(item,childItem){
            this.activeChildItem = childItem;
            this.activeItem = item;
            this.$emit('change-item', item,childItem );
        },
    }
}

</script>

<style scoped>
.menu-container{
    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 16px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #3b62f8;
    color: #fff;
    //font-weight: bold;
}


.child-menu-container{
    width: 100%;
    height: auto;
}
.chile-item-container{
    width: 100px;
    height: 34px;
    padding: 4px 0 4px 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.child-menu-item{
    width: auto;
    height: 26px;
    line-height: 26px;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
}

.child-menu-active{
    background: #3b62f8;
    color: #fff;
}
</style>